<template>
  <stage-card-info-list-item>
    <slot></slot>
    <template v-if="hasBubbleText" #append>
      <v-chip small>
        <span class="grey--text text--darken-2 font-weight-bold">
          {{ bubbleText }}
        </span>
      </v-chip>
    </template>
  </stage-card-info-list-item>
</template>

<script>
import StageCardInfoListItem from './StageCardInfoListItem';

export default {
  name: 'BubbleInfoListItem',
  components: { StageCardInfoListItem },
  props: {
    bubbleText: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    hasBubbleText() {
      return this.bubbleText !== '';
    },
  },
};
</script>
